import { render, staticRenderFns } from "./Chapter.vue?vue&type=template&id=232a8e41&scoped=true&"
import script from "./Chapter.vue?vue&type=script&lang=js&"
export * from "./Chapter.vue?vue&type=script&lang=js&"
import style0 from "./Chapter.vue?vue&type=style&index=0&id=232a8e41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232a8e41",
  null
  
)

component.options.__file = "Chapter.vue"
export default component.exports